module.exports = __webpack_public_path__ + "amazon-pay.5b01849d859de394280d7a30b58a7b28.svg";